<template>
      <div v-if="visible" class="overlay">
        <div class="backdrop">
          <p class="message">{{ message }}</p>
        </div>
        <img class="character" :src="characterSrc" alt="Afternoon Greedling" />
        <img class="seed" :src="seedSrc" alt="Green seed" />
      </div>
  </template>
  
  <script>
  export default {
    props: {
      message: {
        type: String,
        required: true,
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        characterSrc: require('@/assets/game-characters/greedling_3.gif'),
        seedSrc: require('@/assets/seeds/afternoon_seed_fail.gif')
      };
    },
  };
  </script>
  
  <style scoped>
.overlay {
  position: fixed; /* Cover the entire screen */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.8); /* Dark overlay */
}

.backdrop {
  position: absolute;
  top: 30%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust for the element's size */
  width: 80%; /* Optional: control message box width */
  max-width: 800px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.9); /* Semi-transparent white */
  color: black;
  text-align: center;
  font-size: 1.5rem; /* Adjust font size for readability */
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  min-height: 200px;
}

.character {
  position: fixed; /* Fixed positioning for the character */
  bottom: 10px; /* Keep the character at the bottom */
  left: 50%; /* Center horizontally */
  transform: translateX(-50%); /* Adjust for the element's width */
  height: 40%; /* Character height */
  max-width: auto; /* Prevent overly wide scaling */
  z-index: 1; /* Lower stacking order for the character */
}

.seed {
  position: fixed; /* Fixed positioning for the character */
  bottom: 10px; /* Keep the character at the bottom */
  left: 50%; /* Center horizontally */
  transform: translateX(-50%); /* Adjust for the element's width */
  height: 40%; /* Character height */
  max-width: auto; /* Prevent overly wide scaling */
  z-index: 2; /* Lower stacking order for the seed */
}

</style>